import styled from "styled-components";

export const ListItemContainer = styled.div`
  background: #ffffff;
  border-radius: 4px;
  position: relative;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #282e3d;
    line-height: 24px;
    text-align: left;
  }
`;

export const ContactInformation = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
  img {
    width: 24px;
    height: 23px;
    margin-right: 8px;
  }
  span {
    font-weight: 400;
    font-size: 14px;
    color: #484d5a;
    line-height: 20px;
    text-align: left;
  }
`;

export const AddressInformation = styled.div`
  margin-top: 12px;
  span {
    font-weight: 400;
    font-size: 12px;
    color: #737781;
    line-height: 17px;
    text-align: left;
  }
  .ellipsis-multiline {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ActionContainer = styled.div`
  width: 32px;
  background: #f6f7fa;
  border-radius: 0px 0px 4px 4px;
  position: absolute;
  right: 0;
  top: -12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  img {
    width: 18px;
    height: 18px;
    margin: 12px 0;
  }
`;

export const More = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  span {
    font-weight: 400;
    font-size: 12px;
    color: #f08300;
    line-height: 20px;
    text-align: left;
  }
  .arrow {
    width: 18px;
    height: 18px;
    margin-left: 4px;
    transform: rotate(270deg);
  }
`;

export const ClearanceInfo = styled.div`
  background: #f6f7fa;
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 12px;
`;

export const ClearanceInfoItemInfo = styled.div`
  span {
    font-weight: 400;
    font-size: 12px;
    color: #737781;
    line-height: 24px;
    text-align: left;
  }
`;
